import { cn } from '@/common/lib/cn/cn'
import {
    clampThresholdPercent,
    getThresholdVariant,
    thresholdBarClass,
    type ThresholdProgressBarProps,
} from './thresholdProgressBarUtils'

export function ThresholdProgressBar({
    value,
    variant = 'auto',
    className,
    trackClassName,
    'aria-label': ariaLabel,
}: ThresholdProgressBarProps) {
    const percent = clampThresholdPercent(value)
    const resolvedVariant = variant === 'auto' ? getThresholdVariant(percent) : variant

    return (
        <div
            className={cn('w-full h-1 bg-base-200 rounded-full overflow-hidden', trackClassName, className)}
            role='progressbar'
            aria-valuenow={percent}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={ariaLabel}
        >
            <div
                className={cn('h-full rounded-full transition-all', thresholdBarClass[resolvedVariant])}
                style={{ width: `${percent}%` }}
            />
        </div>
    )
}
